import './CasePage.scss';

import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RouteParams } from 'router';
import { useDataQuery, useGTMDataSend } from 'common/hooks';
import { queryCasePage } from 'network';
import { Loader } from '@dataartdev/uikit/Loader';
import { RegularCSPage } from './RegularCSPage';
import { DesignCSPage } from '../../industries/pages';
import { useIntl } from 'react-intl';
import { ICasePage } from './models/CasePage.props';
import { useRedirect404 } from '../../../common/hooks/useRedirect404';

type Props = RouteComponentProps<RouteParams>;

const CasePage: React.FC<Props> = props => {
  const { match, history } = props || {};
  const { locale } = useIntl();
  const { data, loading, error } = useDataQuery<ICasePage>(queryCasePage, {
    locale,
    slug: match.params.slug,
  });

  const { designed, metaTitle, tags } = data || {};

  useRedirect404(error, history);
  useGTMDataSend(metaTitle, tags);

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <>
          {designed ? (
            <DesignCSPage {...props} data={data} />
          ) : (
            <RegularCSPage {...props} data={data} />
          )}
        </>
      )}
    </>
  );
};

export default CasePage;
